module.exports = __webpack_public_path__ + "media/images/login/ttl_gifu-d645340f73358d3ffd7c5ade93ab9b8d.png";